import { goBackendApi } from 'hooks/api/httpApi';
import {
    MarketDrivenStatusUpdateRequest,
    MarketDrivenStatusUpdateRequest_Status,
} from '../../../../pb/requests/v1/market_driven_status_update_request_pb';

export const ACTIVATE_MARKET_DRIVEN_SHIPPING_PATH = '/api/v1/ecom/activate-market-driven';

/**
 * Sets the ecom's market-driven shipping status, sent as a JSON `{ status }` body. A LEGACY ecom is
 * rejected with 400 when activated — it has to be migrated first.
 */
export const activateMarketDrivenShipping = (status: MarketDrivenStatusUpdateRequest_Status) =>
    goBackendApi().patch(ACTIVATE_MARKET_DRIVEN_SHIPPING_PATH, { status } satisfies Pick<
        MarketDrivenStatusUpdateRequest,
        'status'
    >);
